import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import routes from 'app/routes';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import StatisticButton from './StatisticButton';
import StatisticModal from './StatisticModal';

export default function InvitedStatistic({ value }) {
  const [showModal, setShowModal] = useState(false);
  const route = routes.api.managers.dashboard.members_invited;
  const { state: { filters } } = useContext();
  const { data: members, loading: membersLoading } = useApiData(showModal && route, filters);

  const columns = [
    {
      name: 'First Name',
      selector: (row) => row.attributes.first_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.attributes.last_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Program',
      selector: (row) => row.attributes.program_titles,
      sortable: true,
    },
    {
      name: 'Invited On',
      selector: (row) => row.attributes.invited_on,
      sortable: true,
    },
  ];

  return (
    <Col md="4" className="mb-2 mb-md-0">
      <StatisticButton
        label="Invited"
        value={value}
        onClick={() => setShowModal(true)}
        className="bg-primary-50"
      />

      <StatisticModal
        show={showModal}
        title="Invited"
        columns={columns}
        data={membersLoading ? null : members}
        onCloseClick={() => setShowModal(false)}
      />
    </Col>
  );
}

InvitedStatistic.propTypes = {
  value: PropTypes.number,
};

InvitedStatistic.defaultProps = {
  value: null,
};
